import * as vp from 'vopay';
import { FunctionComponent, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLayout } from '../../../../../../providers/Layout.provider';
import type { BankAccountLoginHandler } from '../types';
import styles from './AccountSelection.module.scss';

const { Box, Button, Title, Icon } = vp;

type AccountSelectionProps = {
  handlers: BankAccountLoginHandler;
  accounts: vp.BankAccountConnection[];
};

type FC = FunctionComponent<AccountSelectionProps>;

const AccountSelection: FC = (props: AccountSelectionProps) => {
  const { handlers, accounts } = props;
  const { color } = useLayout();
  const { t } = useTranslation('translations', { keyPrefix: 'OnlineBanking' });
  const [selectedBankAccountID, setBankAccountID] = useState(accounts[0]?.BankAccountID || 441);
  return (
    <>
      <Box flx="col" pb="md" width="100%" height="auto">
        <Title title={`${t('selectAnAccountTitle')}`} />
      </Box>
      <Box flx="col" pb="md" width="100%" height="auto">
        {accounts.map(({ AccountNumber, BankAccountID, Currency, CurrentBalance, AccountType }) => (
          <button
            key={BankAccountID}
            className={styles.selectionBlock}
            type="button"
            onClick={() => {
              setBankAccountID(BankAccountID);
            }}
          >
            {BankAccountID === selectedBankAccountID && (
              <span className={styles.checkMark}>
                {' '}
                <Icon icon="check" size="sm" />
              </span>
            )}
            <span className={styles.selectionBlockItemLeft}>
              {AccountType} ({maskAccountNumber(AccountNumber)})
            </span>
            <span className={styles.selectionBlockItemRight}>
              {formatCurrency(CurrentBalance)} {Currency}
            </span>
          </button>
        ))}
      </Box>
      <Box mt="sm" height="auto">
        <Button
          id="login"
          label={`${t('connect')}`}
          type="submit"
          background={color}
          textColor={vp.getContrastColor(color)}
          width="100%"
          size="xlg"
          round
          bold
          noShadow
          textSize={1}
          onClick={() => {
            handlers.selectBankAccount(selectedBankAccountID);
          }}
        />
      </Box>
    </>
  );
  function maskAccountNumber(accountNumber: number): string {
    const last4 = accountNumber.toString().slice(-4);
    return `***${last4}`;
  }
  function formatCurrency(amount: number): string {
    const formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2,
    });
    return formatter.format(amount);
  }
};

export default AccountSelection;
